import { ElementDetails } from "@/lib/types";
import { SlackActivityProps } from "./types";

export const details = {
  name: "SlackActivity",
  description: "Your recent Slack mentions, like Slack's Activity tab",
  tags: ["Communication"],
  category: "Slack",
  grid: { default: [3, 4], large: [4, 5] },
  gridNames: { default: "Medium", large: "Large" },
  integrationsUsed: ["slack"],
  defaultProps: {},
} as ElementDetails<SlackActivityProps>;
